import React from 'react'

import classes from '../EmployeeActions.scss'
import icons from '../../../../../../../../icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { IconButton } from '@material-ui/core'
import { Link } from 'react-router-dom'

const editButton = ({ recordId, disabled }) => {
  let buttonComponent = null
  if (disabled) {
    buttonComponent = (
      <div className={classes.ActionButton}>
        <IconButton className={classes.ButtonOverride} size={'small'} disabled={disabled}>
          <FontAwesomeIcon icon={icons.faEdit} />
        </IconButton>
      </div>
    )
  } else {
    buttonComponent = (
      <Link className={classes.ActionButton} to={`/employee/${recordId}`}>
        <IconButton className={classes.ButtonOverride} size={'small'}>
          <FontAwesomeIcon icon={icons.faEdit} />
        </IconButton>
      </Link>
    )
  }
  return buttonComponent
}

export default editButton
